import { GetterTree, MutationTree } from "vuex";
import { RootState } from "vuefront-store";

export type HomeSeo = {
  h1?: string;
  robots?: string;
  robotsReady?: boolean;
  dateModified?: string;
  meta?: {
    title?: string;
    description?: string;
    keyword?: string;
  };
};

export type State = {
  home: HomeSeo;
};

export const state = (): State => ({
  home: {},
});

export const getters: GetterTree<State, RootState> = {
  get(currentState) {
    return currentState.home;
  },
};

export const mutations: MutationTree<State> = {
  setHome(currentState, home) {
    currentState.home = home && typeof home === "object" ? home : {};
  },
};
